@let shadowClass =
  hasShadowCta() ? "drop-shadow-custom active:translate-x-0.5 active:translate-y-0.5 active:drop-shadow-none" : "";
@if (isLoaded()) {
  @if (inline() && svgContent()) {
    <div class="flex items-center justify-center">
      <div
        [class]="shadowClass"
        [innerHTML]="svgContent()"
        [ngStyle]="
          isFullSize()
            ? { 'height.%': 100, 'width.%': 100 }
            : { 'height.px': effectiveHeight(), 'width.px': effectiveWidth() }
        "
        class="flex items-center justify-center overflow-hidden"></div>
    </div>
  } @else if (srcCdn()) {
    @if (isFullSize()) {
      <ng-container *ngTemplateOutlet="imageTemplate" />
    } @else {
      <div [style.height.px]="height()" [style.width.px]="width()" class="relative flex items-center justify-center">
        <img
          [alt]="alt() ?? ''"
          [attr.decoding]="isPriority() ? 'sync' : 'async'"
          [attr.fetchpriority]="isPriority() ? 'high' : 'auto'"
          [attr.loading]="isPriority() ? 'eager' : 'lazy'"
          [class]="'max-w-full max-h-full object-contain ' + shadowClass"
          [src]="srcCdn()" />
      </div>
    }
  }
}
<ng-template #imageTemplate>
  <img
    [alt]="alt() ?? ''"
    [attr.decoding]="isPriority() ? 'sync' : 'async'"
    [attr.fetchpriority]="isPriority() ? 'high' : 'auto'"
    [attr.loading]="isPriority() ? 'eager' : 'lazy'"
    [class]="shadowClass"
    [src]="srcCdn()" />
</ng-template>
